import { combineReducers } from 'redux';
import appInfo from './appInfo/AppInfoSlice';
import { loginReducer as login, loginPersistReducer as persistLogin } from './login/LoginSlice';
import profile from './profile/ProfileSlice';
import myWorld from './profile/myWorld/MyWorldSlice';
import timeline from './timeline/TimelineSlice';
import globalError from './globalError/GlobalErrorSlice';
import accident from './accident/AccidentSlice';
import nurserySetting from './nursery/NurserySlice';
import pushNotification from './misc/push-notification/PushNotificationSlice';
import misc from './misc/MiscSlice';
import appTimer from './appTimers/AppTimerSlice';
import eyengage from './eyengage/EyengageSlice';
import account from './account/AccountSlice';
import notifications from './notifications/NotificationSlice';
import communication from './messages/communication/CommunicationSlice';
import conversation from './messages/conversations/ConversationsSlice';
import inbox from './messages/inbox/InboxSlice';
import sentbox from './messages/sentbox/SentBoxSlice';
import conversationParticipant from './messages/conversations/participants/ConversationParticipantsSlice';
import { 
  eymemoryLoginReducer as eymemoryLogin,
   eymemoryLoginPersistReducer  as eymemoryPersistLogin
} from './eymemory/EymemoryLoginSlice';
import emailNotification from './misc/email-notification/EmailNotificationSlice';
import forceUpdate from './misc/app-force-update/ForceUpdateSlice';
import rateLimit from './misc/app-rate-limit/RateLimitSlice';

export default combineReducers({
  appInfo,
  login,
  persistLogin,
  profile,
  myWorld,
  timeline,
  globalError,
  accident,
  nurserySetting,
  pushNotification,
  misc,
  appTimer,
  eyengage,
  account,
  notifications,
  communication,
  conversation,
  inbox,
  sentbox,
  conversationParticipant,
  eymemoryLogin,
  eymemoryPersistLogin,
  emailNotification,
  forceUpdate,
  rateLimit
});

